/**
 * ETournify Priority support helpers (MooseDesk).
 * Detect Premium, mark chat CTAs, open widget reliably, seed Premium marker.
 */
(function () {
  if (window.ETN && window.ETN.__premiumSupportReady) return;

  var PREMIUM_PREFIX = "[Premium priority] ";
  var STARTER =
    "[Premium priority] Hi — I'm a Premium member. Please prioritize this request. ";

  function ensureEtn() {
    window.ETN = window.ETN || {};
    return window.ETN;
  }

  // Premium gate: do NOT hide/strip tags until status is resolved.
  // Previous bug: locked everyone before /me returned, then never restored tags.
  if (typeof window.__ETN_IS_PREMIUM !== "boolean") {
    window.__ETN_IS_PREMIUM = !!window.ETN_SHOPIFY_PREMIUM_TAG;
  }
  if (typeof window.__ETN_PREMIUM_RESOLVED !== "boolean") {
    window.__ETN_PREMIUM_RESOLVED = !!window.ETN_SHOPIFY_PREMIUM_TAG;
  }

  var savedLiveChatFormFields = null;
  var savedTicketFormFields = null;

  function isPremium() {
    if (window.__ETN_IS_PREMIUM === true) return true;
    try {
      if (document.body && document.body.classList.contains("etn-user-is-premium")) {
        return true;
      }
    } catch (e) {}
    return !!window.ETN_SHOPIFY_PREMIUM_TAG;
  }

  function isFreeUserResolved() {
    return window.__ETN_PREMIUM_RESOLVED === true && !isPremium();
  }

  function markPremium(on) {
    window.__ETN_IS_PREMIUM = !!on;
    window.__ETN_PREMIUM_RESOLVED = true;
    try {
      if (on) document.body.classList.add("etn-user-is-premium");
      else document.body.classList.remove("etn-user-is-premium");
    } catch (e) {}
    if (typeof window.etnApplyPremiumUi === "function") {
      try {
        window.etnApplyPremiumUi(!!on);
      } catch (err) {}
    }
    try {
      enforcePremiumTagPolicy();
    } catch (err2) {}
  }

  function detectPremium(cb) {
    if (
      window.__ETN_IS_PREMIUM === true ||
      (document.body && document.body.classList.contains("etn-user-is-premium")) ||
      window.ETN_SHOPIFY_PREMIUM_TAG
    ) {
      markPremium(true);
      if (typeof cb === "function") cb(true);
      return Promise.resolve(true);
    }

    return fetch("/apps/etournify/me/username?_ts=" + Date.now(), {
      method: "GET",
      credentials: "same-origin",
      headers: { Accept: "application/json" },
      cache: "no-store"
    })
      .then(function (r) {
        return r && r.ok ? r.json() : null;
      })
      .then(function (data) {
        var on = !!(data && data.ok && data.is_premium === true);
        markPremium(on);
        if (typeof cb === "function") cb(on);
        return on;
      })
      .catch(function () {
        markPremium(!!window.ETN_SHOPIFY_PREMIUM_TAG);
        if (typeof cb === "function") cb(isPremium());
        return isPremium();
      });
  }

  function showNotes(selectorList) {
    var list = Array.isArray(selectorList) ? selectorList : [selectorList];
    list.forEach(function (sel) {
      if (!sel) return;
      var nodes = document.querySelectorAll(sel);
      Array.prototype.forEach.call(nodes, function (el) {
        el.hidden = false;
        el.removeAttribute("hidden");
        el.classList.add("is-visible");
      });
    });
  }

  function setChatLabels(map) {
    if (!map) return;
    Object.keys(map).forEach(function (sel) {
      var nodes = document.querySelectorAll(sel);
      Array.prototype.forEach.call(nodes, function (el) {
        el.textContent = map[sel];
      });
    });
  }

  function mooseRoot() {
    var host = document.getElementById("moosedesk-widget-host");
    if (host && host.shadowRoot) return host.shadowRoot;
    return document;
  }

  function mooseQuery(sel) {
    var root = mooseRoot();
    return root.querySelector(sel) || document.querySelector(sel);
  }

  function getFloatBtn() {
    return (
      mooseQuery("#help-widget-moosedesk .mdw-float-btn") ||
      mooseQuery(".mdw-float-btn")
    );
  }

  function getDeepLinkHash() {
    var settings = window.mdSettings && window.mdSettings.widget_settings;
    var deepLinks = settings && settings.deepLinks;
    if (deepLinks && deepLinks.openWidget) {
      return deepLinks.openWidget.indexOf("#") === 0
        ? deepLinks.openWidget
        : "#" + deepLinks.openWidget;
    }
    return "#open-widget";
  }

  /* The launcher stays hidden; a programmatic click still opens the chat.
     Never put inline styles on it — inline !important beats the hide CSS
     and the bubble reappears in the corner. */
  function armFloatButton(btn) {
    var ETN = ensureEtn();
    if (typeof ETN.showMooseDeskHost === "function") ETN.showMooseDeskHost();
    return btn || null;
  }

  /* Only trust what is actually on screen. MooseDesk leaves state classes
     behind when the chat is closed from its own X, which made the next
     click "close" an already-closed chat. */
  function isMooseDeskOpen() {
    var popup =
      mooseQuery("#help-widget-moosedesk .mdw-popup-widget") ||
      mooseQuery(".mdw-popup-widget");
    if (!popup || popup.classList.contains("mdw-popup-widget-hidden")) return false;

    var rect = popup.getBoundingClientRect();
    if (rect.width < 2 || rect.height < 2) return false;

    if (typeof popup.checkVisibility === "function") {
      return popup.checkVisibility({ opacityProperty: true, visibilityProperty: true });
    }
    var style = window.getComputedStyle(popup);
    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      parseFloat(style.opacity || "1") > 0.05
    );
  }

  function getCloseButton() {
    return (
      mooseQuery("#help-widget-moosedesk .md-close-popup") ||
      mooseQuery("#help-widget-moosedesk .custom-popup-widget__close-icon") ||
      mooseQuery(".md-close-popup") ||
      mooseQuery(".custom-popup-widget__close-icon") ||
      mooseQuery(".mdw-popup-widget-close")
    );
  }

  function clearDeepLinkHash() {
    try {
      if (window.location.hash === getDeepLinkHash() && window.history && window.history.replaceState) {
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
      }
    } catch (e) {}
  }

  /* One opener at a time, checking the screen between them. Firing several
     at once (hash + synthetic click + el.click) toggles the chat open and
     shut again, so the user had to click twice. */
  var openRun = 0;
  function openMooseDeskChat() {
    armFloatButton(null);
    if (isMooseDeskOpen()) {
      if (isPremium()) watchAndSeedComposer(10000);
      return true;
    }

    var run = ++openRun;
    var step = 0;
    var waited = 0;
    clearDeepLinkHash();

    function finish() {
      clearDeepLinkHash();
      if (isPremium()) watchAndSeedComposer(10000);
    }

    function tick() {
      if (run !== openRun) return;
      if (isMooseDeskOpen()) return finish();

      var btn = getFloatBtn();
      if (!btn && waited < 40) {
        waited += 1;
        window.setTimeout(tick, 150);
        return;
      }

      if (step === 0 && btn) {
        step = 1;
        try { btn.click(); } catch (e) {}
        window.setTimeout(tick, 450);
        return;
      }
      if (step <= 1 && btn) {
        step = 2;
        try {
          btn.dispatchEvent(new MouseEvent("mousedown", { bubbles: true, cancelable: true, view: window }));
          btn.dispatchEvent(new MouseEvent("mouseup", { bubbles: true, cancelable: true, view: window }));
        } catch (e) {}
        window.setTimeout(tick, 450);
        return;
      }
      if (step <= 2) {
        step = 3;
        try { window.location.hash = getDeepLinkHash(); } catch (e) {}
        window.setTimeout(tick, 450);
        return;
      }
      finish();
    }

    tick();
    return true;
  }

  function closeMooseDeskChat() {
    openRun += 1;
    var closeBtn = getCloseButton();
    if (closeBtn) {
      try { closeBtn.click(); } catch (e) {}
      return true;
    }
    var btn = getFloatBtn();
    if (btn) {
      try { btn.click(); } catch (e) {}
    }
    return true;
  }

  function toggleMooseDeskChat() {
    if (isMooseDeskOpen()) return closeMooseDeskChat();
    return openMooseDeskChat();
  }

  function findComposer() {
    var selectors = [
      "#help-widget-moosedesk textarea",
      ".mdw-popup-widget textarea",
      "#help-widget-moosedesk [contenteditable='true']",
      ".mdw-popup-widget [contenteditable='true']",
      "textarea.mdw-input",
      "textarea[placeholder*='essage']",
      "textarea[placeholder*='ype']"
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function setComposerValue(el, text) {
    if (!el) return false;
    if (el.isContentEditable) {
      if ((el.textContent || "").trim()) return false;
      el.textContent = text;
      el.dispatchEvent(new Event("input", { bubbles: true }));
      return true;
    }
    if ((el.value || "").trim()) return false;
    el.value = text;
    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
    return true;
  }

  function trySeedMooseDeskComposer(force) {
    if (!isPremium() && !force) return false;
    var el = findComposer();
    if (!el) return false;
    return setComposerValue(el, STARTER);
  }

  function trySelectPremiumWidgetTag() {
    if (!isPremium()) return false;
    var roots = [
      document.querySelector("#help-widget-moosedesk"),
      document.querySelector(".mdw-popup-widget"),
      document.body
    ];
    var keywords = ["premium", "priority"];
    var i;
    var j;
    var k;

    function labelMatches(text) {
      var t = String(text || "").trim().toLowerCase();
      if (!t || t === "no data" || t.indexOf("select tag") !== -1) return false;
      return keywords.some(function (kw) {
        return t === kw || t.indexOf(kw) !== -1;
      });
    }

    function pickBestOption(nodes) {
      var best = null;
      var bestScore = -1;
      for (j = 0; j < nodes.length; j++) {
        var el = nodes[j];
        var text = String(el.textContent || "").trim().toLowerCase();
        if (!labelMatches(text)) continue;
        var score = 0;
        if (text === "premium") score = 3;
        else if (text.indexOf("premium") !== -1) score = 2;
        else if (text.indexOf("priority") !== -1) score = 1;
        if (score > bestScore) {
          bestScore = score;
          best = el;
        }
      }
      return best;
    }

    for (i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (!root) continue;

      // Native <select>
      var selects = root.querySelectorAll("select");
      for (j = 0; j < selects.length; j++) {
        var sel = selects[j];
        if (!sel || !sel.options || !sel.options.length) continue;
        for (k = 0; k < sel.options.length; k++) {
          var opt = sel.options[k];
          if (!labelMatches(opt.textContent || opt.value)) continue;
          if (sel.value !== opt.value) {
            sel.value = opt.value;
            sel.dispatchEvent(new Event("input", { bubbles: true }));
            sel.dispatchEvent(new Event("change", { bubbles: true }));
          }
          return true;
        }
      }

      // MooseDesk "Select tags" searchable field
      var tagInputs = root.querySelectorAll(
        'input[placeholder*="Select tags" i], input[placeholder*="tag" i], .ant-select-selection-search-input, [class*="select"] input'
      );
      for (j = 0; j < tagInputs.length; j++) {
        var input = tagInputs[j];
        try {
          input.focus();
          input.click();
          input.dispatchEvent(
            new MouseEvent("mousedown", { bubbles: true, cancelable: true, view: window })
          );
          // Type to filter if the list is searchable
          if ("value" in input) {
            input.value = "Premium";
            input.dispatchEvent(new Event("input", { bubbles: true }));
            input.dispatchEvent(new KeyboardEvent("keydown", { bubbles: true, key: "Premium" }));
          }
        } catch (e) {}
      }

      // Options that appear after opening the dropdown
      var optionNodes = root.querySelectorAll(
        '[role="option"], .ant-select-item-option, .rc-select-item-option, [class*="option"], li, .mdw-tag, .tag-item'
      );
      var pick = pickBestOption(optionNodes);
      if (pick) {
        try {
          pick.click();
          return true;
        } catch (e) {}
      }

      // Already-rendered chips / list items
      var clickables = root.querySelectorAll(
        "[role='option'], .mdw-tag, .tag-item, .md-tag, button, li, span, div"
      );
      pick = pickBestOption(clickables);
      if (pick) {
        try {
          pick.click();
          return true;
        } catch (e) {}
      }
    }
    return false;
  }

  function watchAndSeedComposer(ms) {
    if (!isPremium()) return;
    var until = Date.now() + (ms || 8000);
    var timer = window.setInterval(function () {
      var seeded = trySeedMooseDeskComposer(true);
      var tagged = trySelectPremiumWidgetTag();
      if ((seeded && tagged) || Date.now() > until) {
        window.clearInterval(timer);
      }
    }, 350);
  }

  function tagContactForm(form) {
    if (!form || !isPremium()) return;
    var subject = form.querySelector('[name="contact[subject]"]');
    var body = form.querySelector('[name="contact[body]"]');

    if (subject && subject.value && subject.value.indexOf("[Premium") === -1) {
      subject.value = PREMIUM_PREFIX + subject.value.replace(/^\s+/, "");
    }

    if (body && body.value && body.value.indexOf("[Premium") === -1) {
      body.value = PREMIUM_PREFIX + body.value.replace(/^\s+/, "");
    }

    var flag = form.querySelector('[name="contact[etn_priority]"]');
    if (!flag) {
      flag = document.createElement("input");
      flag.type = "hidden";
      flag.name = "contact[etn_priority]";
      flag.value = "premium";
      form.appendChild(flag);
    }
  }

  function bindContactPriority(form) {
    if (!form || form.dataset.etnPriorityBound === "1") return;
    form.dataset.etnPriorityBound = "1";
    form.addEventListener("submit", function () {
      tagContactForm(form);
    });
  }

  function isPremiumTagLabel(text) {
    var t = String(text || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
    if (!t || t === "no data" || t.indexOf("select tag") !== -1) return false;
    return (
      t === "premium" ||
      t === "priority" ||
      t === "etn_premium" ||
      t.indexOf("premium") !== -1 ||
      t.indexOf("priority") !== -1
    );
  }

  function ensureTagInFields(fields, fallback) {
    var base = Array.isArray(fields) ? fields.slice() : Array.isArray(fallback) ? fallback.slice() : [];
    var hasTag = base.some(function (f) {
      return String(f || "").toLowerCase() === "tag";
    });
    if (!hasTag) base.push("tag");
    return base;
  }

  function stripTagFromFormFields(fields) {
    if (!Array.isArray(fields)) return fields;
    return fields.filter(function (f) {
      return String(f || "").toLowerCase() !== "tag";
    });
  }

  function getMdSettingsObject() {
    var md = window.mdSettings;
    if (!md) return null;
    var ws = md.widget_settings;
    return (ws && ws.settings) || md.settings || null;
  }

  function rememberMdFormFields() {
    var settings = getMdSettingsObject();
    if (!settings) return;
    if (savedLiveChatFormFields == null && Array.isArray(settings.liveChatFormFields)) {
      savedLiveChatFormFields = settings.liveChatFormFields.slice();
    }
    if (savedTicketFormFields == null && Array.isArray(settings.ticketFormFields)) {
      savedTicketFormFields = settings.ticketFormFields.slice();
    }
  }

  function patchMdSettingsForPremiumGate() {
    var settings = getMdSettingsObject();
    if (!settings) return;
    rememberMdFormFields();

    if (isPremium()) {
      settings.liveChatFormFields = ensureTagInFields(
        savedLiveChatFormFields || settings.liveChatFormFields,
        ["name", "email", "tag"]
      );
      settings.ticketFormFields = ensureTagInFields(
        savedTicketFormFields || settings.ticketFormFields,
        ["name", "email", "subject", "message", "tag"]
      );
      return;
    }

    // Only strip after we know this is a free account
    if (!isFreeUserResolved()) return;
    if (Array.isArray(settings.liveChatFormFields)) {
      settings.liveChatFormFields = stripTagFromFormFields(
        savedLiveChatFormFields || settings.liveChatFormFields
      );
    }
    if (Array.isArray(settings.ticketFormFields)) {
      settings.ticketFormFields = stripTagFromFormFields(
        savedTicketFormFields || settings.ticketFormFields
      );
    }
  }

  function filterTagPayload(payload) {
    if (!isFreeUserResolved()) return payload;
    try {
      if (Array.isArray(payload)) {
        return payload.filter(function (item) {
          if (typeof item === "string") return !isPremiumTagLabel(item);
          if (item && typeof item === "object") {
            var name = item.name || item.title || item.label || item.tag || item.value || "";
            return !isPremiumTagLabel(name);
          }
          return true;
        });
      }
      if (payload && typeof payload === "object") {
        if (Array.isArray(payload.data)) {
          payload.data = filterTagPayload(payload.data);
        }
        if (Array.isArray(payload.tags)) {
          payload.tags = filterTagPayload(payload.tags);
        }
      }
    } catch (e) {}
    return payload;
  }

  function isTagStoreUrl(url) {
    var u = String(url || "");
    return /\/api\/v1\/tag\/store/i.test(u) || (/\/api\/v1\/tag/i.test(u) && /moosedesk/i.test(u));
  }

  function installTagApiInterceptor() {
    if (window.__ETN_MD_TAG_INTERCEPT) return;
    window.__ETN_MD_TAG_INTERCEPT = true;

    if (typeof window.fetch === "function") {
      var nativeFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        var url = typeof input === "string" ? input : input && input.url;
        return nativeFetch(input, init).then(function (response) {
          // Pass through until we know the user is free
          if (!isTagStoreUrl(url) || !isFreeUserResolved()) return response;
          return response
            .clone()
            .json()
            .then(function (body) {
              var filtered = filterTagPayload(body);
              if (filtered && Array.isArray(filtered.data)) filtered.data = [];
              else if (Array.isArray(filtered)) filtered = [];
              return new Response(JSON.stringify(filtered), {
                status: response.status,
                statusText: response.statusText,
                headers: response.headers
              });
            })
            .catch(function () {
              return response;
            });
        });
      };
    }

    if (typeof window.XMLHttpRequest === "function") {
      var NativeXHR = window.XMLHttpRequest;
      function WrappedXHR() {
        var xhr = new NativeXHR();
        var openUrl = "";
        var nativeOpen = xhr.open;
        xhr.open = function () {
          openUrl = arguments[1] || "";
          return nativeOpen.apply(xhr, arguments);
        };
        xhr.addEventListener("readystatechange", function () {
          if (xhr.readyState !== 4 || !isFreeUserResolved() || !isTagStoreUrl(openUrl)) return;
          try {
            var raw = xhr.responseText;
            if (!raw) return;
            var parsed = JSON.parse(raw);
            if (parsed && Array.isArray(parsed.data)) parsed.data = [];
            else if (Array.isArray(parsed)) parsed = [];
            else parsed = filterTagPayload(parsed);
            Object.defineProperty(xhr, "responseText", {
              configurable: true,
              get: function () {
                return JSON.stringify(parsed);
              }
            });
            try {
              Object.defineProperty(xhr, "response", {
                configurable: true,
                get: function () {
                  return parsed;
                }
              });
            } catch (e2) {}
          } catch (e) {}
        });
        return xhr;
      }
      WrappedXHR.prototype = NativeXHR.prototype;
      window.XMLHttpRequest = WrappedXHR;
    }
  }

  function injectTagLockStyles() {
    if (document.getElementById("etn-md-tag-lock-style")) return;
    var style = document.createElement("style");
    style.id = "etn-md-tag-lock-style";
    style.textContent =
      "body:not(.etn-user-is-premium) .etn-md-tag-locked," +
      "body:not(.etn-user-is-premium) .etn-md-tag-locked-chip," +
      "body:not(.etn-user-is-premium) .etn-md-tag-field-locked{" +
      "display:none!important;visibility:hidden!important;pointer-events:none!important;" +
      "height:0!important;max-height:0!important;overflow:hidden!important;margin:0!important;padding:0!important}" +
      "body:not(.etn-user-is-premium) .ant-select-dropdown .etn-md-tag-locked," +
      "body:not(.etn-user-is-premium) .rc-select-dropdown .etn-md-tag-locked{" +
      "display:none!important}";
    (document.head || document.documentElement).appendChild(style);
  }

  // The sweeps below run over document.body, so they can reach ETournify's own UI.
  // Anything with an etn- class (match intro chip, premium badges, …) is ours, never MooseDesk's.
  function isEtnOwnNode(el) {
    var node = el;
    for (var i = 0; i < 8 && node && node.nodeType === 1; i++) {
      if (node.id === "etn-match-intro-root") return true;
      var raw = node.className;
      if (raw && typeof raw !== "string" && raw.baseVal != null) raw = raw.baseVal;
      // etn-md-tag-* markers are stamped by this file onto MooseDesk nodes, so they don't count.
      var cls = " " + String(raw || "").replace(/etn-md-tag-[\w-]*/g, " ") + " ";
      if (/\setn-/.test(cls)) return true;
      node = node.parentElement;
    }
    return false;
  }

  function hideTagFieldNode(el) {
    if (!el || el.classList.contains("etn-md-tag-field-locked")) return;
    if (isEtnOwnNode(el)) return;
    var wrap =
      (el.closest &&
        (el.closest(".ant-form-item") ||
          el.closest(".ant-row") ||
          el.closest("[class*='form-item']") ||
          el.closest("[class*='FormItem']") ||
          el.closest("label") ||
          el.parentElement)) ||
      el;
    wrap.classList.add("etn-md-tag-field-locked");
    wrap.hidden = true;
    if (wrap.style) {
      wrap.style.setProperty("display", "none", "important");
      wrap.style.setProperty("pointer-events", "none", "important");
    }
  }

  function unlockTagFieldNodes() {
    var locked = document.querySelectorAll(
      ".etn-md-tag-locked, .etn-md-tag-locked-chip, .etn-md-tag-field-locked"
    );
    Array.prototype.forEach.call(locked, function (el) {
      el.classList.remove("etn-md-tag-locked", "etn-md-tag-locked-chip", "etn-md-tag-field-locked");
      el.hidden = false;
      el.removeAttribute("aria-disabled");
      if (el.tagName === "OPTION") el.disabled = false;
      if (el.style) {
        el.style.removeProperty("display");
        el.style.removeProperty("pointer-events");
        el.style.removeProperty("height");
        el.style.removeProperty("max-height");
        el.style.removeProperty("overflow");
        el.style.removeProperty("margin");
        el.style.removeProperty("padding");
      }
    });
  }

  function lockPremiumTagsInWidget() {
    patchMdSettingsForPremiumGate();
    injectTagLockStyles();

    // Premium or still detecting: keep tags visible
    if (!isFreeUserResolved()) {
      unlockTagFieldNodes();
      return;
    }

    var roots = [
      document.querySelector("#help-widget-moosedesk"),
      document.querySelector(".mdw-popup-widget"),
      document.querySelector(".ant-select-dropdown"),
      document.querySelector(".rc-select-dropdown"),
      document.body
    ];

    roots.forEach(function (root) {
      if (!root) return;

      root
        .querySelectorAll(
          'input[placeholder*="Select tags" i], input[placeholder*="tag" i], [aria-label*="Select tags" i], [aria-label*="tag" i]'
        )
        .forEach(function (el) {
          hideTagFieldNode(el);
        });

      root.querySelectorAll("label, span, div, p").forEach(function (el) {
        var text = String(el.textContent || "").trim().toLowerCase();
        if (text === "select tags" || text === "tags") hideTagFieldNode(el);
      });

      root.querySelectorAll("select option").forEach(function (opt) {
        if (isEtnOwnNode(opt)) return;
        if (!isPremiumTagLabel(opt.textContent || opt.value)) return;
        opt.disabled = true;
        opt.hidden = true;
        opt.classList.add("etn-md-tag-locked");
        try {
          opt.remove();
        } catch (e) {}
      });

      root
        .querySelectorAll(
          '[role="option"], .ant-select-item-option, .rc-select-item-option, .ant-select-item, li, .mdw-tag, .tag-item'
        )
        .forEach(function (el) {
          if (isEtnOwnNode(el)) return;
          var text = String(el.textContent || "").trim();
          if (text.length > 48) return;
          if (!isPremiumTagLabel(text)) return;
          el.classList.add("etn-md-tag-locked");
          el.setAttribute("aria-disabled", "true");
          el.hidden = true;
          if (el.style) {
            el.style.setProperty("display", "none", "important");
            el.style.setProperty("pointer-events", "none", "important");
          }
          try {
            el.remove();
          } catch (e) {}
        });

      root.querySelectorAll("[class*='tag'], [class*='chip'], [class*='selected']").forEach(function (el) {
        if (isEtnOwnNode(el)) return;
        var text = String(el.textContent || "").trim();
        if (text.length > 48) return;
        if (!isPremiumTagLabel(text)) return;
        el.classList.add("etn-md-tag-locked-chip");
        try {
          var closer =
            el.querySelector("[class*='close'], [class*='remove'], .anticon-close, button") || el;
          if (closer && closer !== el) closer.click();
          else el.remove();
        } catch (e) {
          try {
            el.remove();
          } catch (err) {}
        }
      });
    });
  }

  function blockPremiumTagClicks(event) {
    if (!isFreeUserResolved()) return;
    var el = event.target;
    if (!el) return;
    var node = el;
    for (var i = 0; i < 6 && node; i++) {
      var text = String(node.textContent || "").trim();
      var title = String(
        (node.getAttribute && (node.getAttribute("title") || node.getAttribute("aria-label"))) || ""
      ).trim();
      if (
        (text && text.length <= 48 && isPremiumTagLabel(text)) ||
        (title && isPremiumTagLabel(title))
      ) {
        var inWidget =
          !node.closest ||
          node.closest("#help-widget-moosedesk") ||
          node.closest(".mdw-popup-widget") ||
          node.closest("[class*='mdw-']") ||
          node.closest(".ant-select-dropdown") ||
          node.closest(".rc-select-dropdown") ||
          node.closest("[class*='select-dropdown']");
        if (inWidget) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === "function") {
            event.stopImmediatePropagation();
          }
          lockPremiumTagsInWidget();
          return;
        }
      }
      node = node.parentElement;
    }
  }

  function enforcePremiumTagPolicy() {
    // Sync if another script already marked premium (crown UI)
    try {
      if (
        !window.__ETN_PREMIUM_RESOLVED &&
        document.body &&
        document.body.classList.contains("etn-user-is-premium")
      ) {
        window.__ETN_IS_PREMIUM = true;
        window.__ETN_PREMIUM_RESOLVED = true;
      }
    } catch (e) {}

    patchMdSettingsForPremiumGate();
    lockPremiumTagsInWidget();
  }

  var tagLockObserver = null;
  var tagLockStarted = false;
  var lastSeedAt = 0;
  function startPremiumTagLock() {
    if (tagLockStarted) {
      enforcePremiumTagPolicy();
      return;
    }
    tagLockStarted = true;

    installTagApiInterceptor();
    injectTagLockStyles();
    enforcePremiumTagPolicy();

    var tries = 0;
    var mdTimer = window.setInterval(function () {
      tries += 1;
      rememberMdFormFields();
      patchMdSettingsForPremiumGate();
      if ((window.mdSettings && savedLiveChatFormFields) || tries > 80) {
        window.clearInterval(mdTimer);
      }
    }, 100);

    var enforceQueued = false;
    function queueEnforce() {
      if (enforceQueued) return;
      enforceQueued = true;
      window.setTimeout(function () {
        enforceQueued = false;
        enforcePremiumTagPolicy();
        if (isPremium() && Date.now() - lastSeedAt > 4000) {
          lastSeedAt = Date.now();
          try {
            watchAndSeedComposer(6000);
          } catch (err) {}
        }
      }, 120);
    }

    if (!tagLockObserver && document.body) {
      tagLockObserver = new MutationObserver(function () {
        queueEnforce();
      });
      try {
        tagLockObserver.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["class"]
        });
      } catch (e) {}
    }

    document.addEventListener("click", blockPremiumTagClicks, true);
    document.addEventListener("mousedown", blockPremiumTagClicks, true);
    document.addEventListener("pointerdown", blockPremiumTagClicks, true);
    document.addEventListener("touchstart", blockPremiumTagClicks, true);

    window.setInterval(function () {
      enforcePremiumTagPolicy();
    }, 1500);
  }

  /**
   * @param {object} opts
   * @param {string|string[]} [opts.noteSelectors]
   * @param {object} [opts.chatLabelMap]
   * @param {HTMLFormElement|string} [opts.contactForm]
   * @param {HTMLElement|string} [opts.chatOpenTrigger]
   * @param {boolean} [opts.triggerOpensChat] if true, trigger click opens MooseDesk
   */
  function bootPrioritySupport(opts) {
    opts = opts || {};

    startPremiumTagLock();

    function apply(on) {
      markPremium(!!on);
      if (!on) {
        enforcePremiumTagPolicy();
        return;
      }
      showNotes(opts.noteSelectors);
      setChatLabels(opts.chatLabelMap || {});
      try {
        document.body.classList.add("etn-priority-support");
      } catch (e) {}

      var form = opts.contactForm;
      if (typeof form === "string") form = document.querySelector(form);
      if (form) bindContactPriority(form);

      var trigger = opts.chatOpenTrigger;
      if (typeof trigger === "string") trigger = document.querySelector(trigger);
      if (trigger && trigger.dataset.etnPrioritySeedBound !== "1") {
        trigger.dataset.etnPrioritySeedBound = "1";
        trigger.addEventListener("click", function (event) {
          if (opts.triggerOpensChat) {
            event.preventDefault();
            event.stopPropagation();
            toggleMooseDeskChat();
          } else {
            watchAndSeedComposer(10000);
          }
        });
      }
      enforcePremiumTagPolicy();
    }

    return detectPremium(apply);
  }

  var ETN = ensureEtn();
  ETN.__premiumSupportReady = true;
  ETN.detectPremium = detectPremium;
  ETN.isPremium = isPremium;
  ETN.bootPrioritySupport = bootPrioritySupport;
  ETN.seedPremiumMooseDesk = watchAndSeedComposer;
  ETN.tagPremiumContactForm = tagContactForm;
  ETN.openMooseDeskChat = openMooseDeskChat;
  ETN.closeMooseDeskChat = closeMooseDeskChat;
  ETN.toggleMooseDeskChat = toggleMooseDeskChat;
  ETN.isMooseDeskOpen = isMooseDeskOpen;
  ETN.lockPremiumTagsInWidget = lockPremiumTagsInWidget;
  ETN.startPremiumTagLock = startPremiumTagLock;
  ETN.enforcePremiumTagPolicy = enforcePremiumTagPolicy;

  installTagApiInterceptor();
  startPremiumTagLock();
  try {
    detectPremium(function () {
      enforcePremiumTagPolicy();
    });
  } catch (e) {
    enforcePremiumTagPolicy();
  }
})();
